import Vue from 'vue'
import login from './login'
import './default/layout/'
import './default/usuario/'
import './default/acessomodulo/'
import './default/acessotela/'
import './default/acessofuncionalidade/'
import './default/acessogrupo/'
import './default/gestaorelatorio/'
import './default/cidade/'
import './default/estado/'
import './default/grupopessoa/'
import './default/modalidade/'
import './default/tabeladesconto/'
import './default/tabelapreco/'
import './default/prazo/'
import './default/marca/'
import './default/segmento/'
import './default/empresa/'
import './default/pessoa/'

// Component
Vue.component('app-login', login)
